import { useEffect } from 'react';
import Image from 'next/image';

import { imgPrefix, triggerEvent } from '../../../utils';

import styles from './WppFloatButton.module.scss';

const WPP_LINK = 'https://wa.me/5511976720449';

const WppFloatButton = () => {
  useEffect(() => {
    triggerEvent('whatsapp_button_view');
  }, []);

  function handleClick() {
    triggerEvent('whatsapp_button_click');
  }

  return (
    <a
      href={WPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      className={styles['wpp-float-button']}
      onClick={handleClick}
      aria-label="Falar no WhatsApp"
    >
      <Image
        src={imgPrefix('/images/shared/whatsapp.svg')}
        alt="WhatsApp"
        width={20}
        height={20}
      />

      <p>Fazer pedido</p>
    </a>
  );
};

export default WppFloatButton;
